(function() { window.GUID_8449db25_47e5_47f8_a05b_69c13555121f = { getGuid: function() { return "8449db25-47e5-47f8-a05b-69c13555121f"; } }; })();
var CS;
(function (CS) {
    class UserHangfireTasks {
        constructor() {
            this.hangfireTimeout = null;
        }
        static CheckIfAnyTasks(jqXHR) {
            let action = jqXHR.getResponseHeader("userhangfiretaskaction");
            let refreshneeded = jqXHR.getResponseHeader("userhangfiretaskrefreshneeded");
            if (action) {
                if (CS.body) {
                    CS.body.trigger("UserHangfireTaskDismissed", action);
                }
                else {
                    CompuSport.DOM.body.trigger("UserHangfireTaskDismissed", action);
                }
            }
            if (refreshneeded) {
                let context = $('#user-hangfire-tasks-container').data('context');
                context.RefreshTasks();
            }
        }
        RefreshTasks() {
            //Test, si IFrame, on ne fait rien
            if (window.self !== window.top)
                return;
            let me = this;
            CompuSport.Ajax.Get(CSParameters.RUrl + "Global/GetUserHangfireTasks", {}, function (response, xhr) {
                me.replaceContent(response);
                let autodismiss = xhr.getResponseHeader("userhangfiretaskautodismiss");
                if (autodismiss) {
                    let userRowId = $('#LoggedUserRowId').val();
                    CompuSport.Ajax.Post("/Global/DismissUserHangfireTask", { userRowId, hangfireId: autodismiss }, (response) => {
                        me.replaceContent(response);
                    });
                }
            });
        }
        handleBehavior() {
            let me = this;
            let $userHangfireTasks = $('#user-hangfire-tasks');
            if ($userHangfireTasks.hasClass('needrefresh')) {
                $userHangfireTasks.removeClass('needrefresh');
                me.RefreshTasks();
                return;
            }
            if ($userHangfireTasks.length > 0) {
                $userHangfireTasks.offon('click.hangfire', '.task', function () {
                    let $task = $(this);
                    let userRowId = $task.data('userrowid');
                    let hangfireId = $task.data('hangfireid');
                    let inProgress = $task.data('inprogress') == "True";
                    if (userRowId && hangfireId && !inProgress) {
                        CompuSport.Ajax.Post("/Global/DismissUserHangfireTask", { userRowId, hangfireId }, (response) => {
                            me.replaceContent(response);
                        });
                    }
                });
            }
        }
        replaceContent(newContent) {
            let me = this;
            let $userHangfireTasks = $('#user-hangfire-tasks');
            let needRefresh = false;
            if ($userHangfireTasks.length > 0) {
                let $response = $(newContent);
                $userHangfireTasks[0].innerHTML = $response[0].innerHTML;
                needRefresh = $response.hasClass('needrefresh');
                if (!$userHangfireTasks.is(':visible')) {
                    $('#user-hangfire-tasks').slideDown();
                }
            }
            else {
                $('#user-hangfire-tasks-container').append(newContent);
                $('#user-hangfire-tasks').slideDown();
                needRefresh = $('#user-hangfire-tasks').hasClass('needrefresh');
            }
            me.handleBehavior();
            if (needRefresh) {
                clearTimeout(me.hangfireTimeout);
                me.hangfireTimeout = setTimeout(() => { me.RefreshTasks(); }, 3000);
            }
        }
    }
    CS.UserHangfireTasks = UserHangfireTasks;
    let instance = new UserHangfireTasks();
    $('#user-hangfire-tasks-container').data('context', instance);
    instance.handleBehavior();
})(CS || (CS = {}));

//# sourceMappingURL=UserHangfireTasks.js.map
